<template>
    <v-footer
            absolute
            class="font-weight-medium px-0"
            app
    >
        <v-row
                justify="center"
                no-gutters
        >
            <WFooterList title="" :list="definitie_links"></WFooterList>
            <WFooterList title="" :list="wovs_services_links"></WFooterList>
            <WFooterList title="" :list="about_us_links"></WFooterList>
            <WFooterList title="" :list="site_links"></WFooterList>
            <v-col cols="12" class="primary darken-3 white--text">
            &copy; {{ new Date().getFullYear() }} — <strong> Winkeliers en Ondernemers Vereniging Suriname</strong>
            </v-col>
        </v-row>
    </v-footer>
</template>

<script>
    import WFooterList from "./WFooterList";
    export default {
        name: 'WFooter',
        components: {WFooterList},
        data: () => ({
            definitie_links: [
                {
                    title: 'Home',
                    route: 'HomePage'
                },
                // {
                //     title: 'Ondernemersplan',
                //     route: 'News'
                // },
                // {
                //     title: 'Bedrijfsnaam',
                //     route: 'News'
                // },
                // {
                //     title: 'Bedrijfsmiddelen',
                //     route: 'News'
                // }
            ],
            wovs_services_links: [
                {
                    title: 'Lid worden',
                    route: 'Registration'
                },
                // {
                //     title: 'Personeel',
                //     route: 'News'
                // },
                // {
                //     title: 'Verzekeringen',
                //     route: 'News'
                // },
                // {
                //     title: 'Marketing',
                //     route: 'News'
                // },
                // {
                //     title: 'Webshop',
                //     route: 'News'
                // },
                // {
                //     title: 'Pensioen',
                //     route: 'News'
                // }
            ],
            site_links: [
                // {
                //     title: 'Home',
                //     route: 'HomePage'
                // },
                // {
                //     title: 'Lid worden',
                //     route: 'Registration'
                // },
                {
                    title: 'In t nieuws',
                    route: 'News'
                },
                // {
                //     title: 'Maak Conntact',
                //     route: 'ContactUs'
                // }
            ],
            about_us_links: [
                {
                    title: 'Maak Conntact',
                    route: 'ContactUs'
                },
                // {
                //     title: 'Organisatie structuur',
                //     route: 'Registration'
                // },
                // {
                //     title: 'Nieuws',
                //     route: 'News'
                // }
            ],
        }),
    };
</script>